module.exports = __webpack_public_path__ + "img/twitter.30adf8ea.svg";